import './summary-popup.js';

const summaryApi = (typeof window !== 'undefined' && window.SummaryPopup) || {};

const {
	updateSummaryContent,
	showSummaryPopup,
	hideSummaryPopup,
	getSummaryState,
	setSummaryState
} = summaryApi;

if (!updateSummaryContent || !showSummaryPopup) {
	throw new Error('[SummaryPopup] Failed to initialize summary popup API');
}

export {
	updateSummaryContent,
	showSummaryPopup,
	hideSummaryPopup,
	getSummaryState,
	setSummaryState
};

